import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-kaishicaiji",
  "use": "icon-kaishicaiji-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-kaishicaiji\"><path d=\"M512 1023.98C229.683 1023.98 0.02 794.317 0.02 512S229.683 0.02 512 0.02 1023.98 229.683 1023.98 512 794.317 1023.98 512 1023.98z m265.769-524.268L370.79 260.014c-20.766-12.247-37.765-2.58-37.765 21.463V762.43c0 24.044 16.999 33.71 37.765 21.463L777.77 544.195c20.767-12.227 20.767-32.256 0-44.483z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol